const blackColor = '#000000';

export default blackColor;
